import { render, staticRenderFns } from "./Applicants.vue?vue&type=template&id=cff88cd2&"
import script from "./Applicants.vue?vue&type=script&lang=js&"
export * from "./Applicants.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports